import { type FC, useEffect } from "react";
import { toast } from "react-toastify";
import {
  useCreateBrandShortMutation,
  useGenerateBrandAdIdMutation,
} from "../../api/brandsAPI";
import Form from "../../components/Form/Form";
import { ValidatorsE } from "../../components/Form/yupValidations";
import { useAppDispatch } from "../../store/hooks";
import { setSelectedBrand } from "../../store/slices/deliveryWizardSlice";
import { TOAST_DURATION } from "../../utils/helpers/constants";
import usePopup from "../../utils/hooks/usePopup";
import { useTranslate } from "../../utils/hooks/useTranslate";

import type { FormFieldT } from "../../models/models";


type CreateNewBrandShortBodyPropTypes = {
  brandName?: string;
};

const CreateNewBrandShortBody: FC<CreateNewBrandShortBodyPropTypes> = ({
  brandName,
}) => {
  const dispatch = useAppDispatch();
  const [generateAdId] = useGenerateBrandAdIdMutation();
  const [createBrand] = useCreateBrandShortMutation();

  const { t } = useTranslate();

  const fields: FormFieldT[] = [
    {
      label: "Name in Hebrew",
      name: "name",
      validation: ValidatorsE.BRAND_NAME,
      defaultValue: brandName,
    },
    {
      label: "Name in English",
      name: "nameEn",
      validation: ValidatorsE.BRAND_NAME,
    },
  ];
  const { removePopup } = usePopup();

  useEffect(() => {
    const nameField = document.getElementsByName("name")?.[0];

    if (nameField) {
      nameField.focus();
    }
  }, []);

  const handleSubmit = async (data: any) => {
    const adId = await generateAdId({ name: data.nameEn });

    if (!("data" in adId)) {
      toast.error(t`Failed to generate AD-ID`, {
        autoClose: TOAST_DURATION,
      });

      return;
    }

    const body = {
      AdId: adId.data,
      Id: null,
      Name: data.name,
      NameEN: data.nameEn,
    };

    try {
      const res: any = await createBrand(body);
      if (!res.error) {
        dispatch(
          setSelectedBrand({
            value: res.data.Id,
            label: res.data.Name,
            shortName: res.data.ShortName,
          })
        );
        removePopup();
        toast("Successfully created", {
          type: "success",
          autoClose: TOAST_DURATION,
        });
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  return (
    <Form
      fields={fields}
      formID="create-brand-short"
      onSubmit={handleSubmit}
      columns={1}
    />
  );
};

export default CreateNewBrandShortBody;
